import { BaseSnackbarProps } from './BaseSnackbar.types';
import { Snackbar as MUISnackbar } from '@mui/material';

/**
 * A customizable snackbar component that wraps the MUI Snackbar component.
 *
 * @param open - {@link BaseSnackbarProps.open open} description.
 * @param key - {@link BaseSnackbarProps.key key} description.
 * @param onClose - {@link BaseSnackbarProps.onClose onClose} description.
 * @param autoHideDuration - {@link BaseSnackbarProps.autoHideDuration autoHideDuration} description.
 * @param TransitionComponent - {@link BaseSnackbarProps.TransitionComponent TransitionComponent} description.
 * @param TransitionProps - {@link BaseSnackbarProps.TransitionProps TransitionProps} description.
 * @param anchorOrigin - {@link BaseSnackbarProps.anchorOrigin anchorOrigin} description.
 * @param classes - {@link BaseSnackbarProps.classes classes} description.
 * @param children - {@link BaseSnackbarProps.children children} description.
 * @param props - {@link BaseSlideProps props} description.
 */
export const BaseSnackbar = ({
    open,
    snackbarKey,
    onClose,
    autoHideDuration,
    TransitionComponent,
    TransitionProps,
    anchorOrigin,
    classes,
    children,
    ...props
}: BaseSnackbarProps) => {
    return (
        <MUISnackbar
            {...props}
            open={open}
            key={snackbarKey}
            onClose={onClose}
            autoHideDuration={autoHideDuration}
            TransitionComponent={TransitionComponent}
            TransitionProps={TransitionProps}
            anchorOrigin={anchorOrigin}
            classes={classes}
        >
            {children}
        </MUISnackbar>
    );
};